module.exports = __webpack_public_path__ + "images/da8ecd25396d8ff351e3da5a8ea08569-logo.png";